import React from 'react'

import PrintIcon from '@mui/icons-material/Print'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'

import type { RootState } from 'reduxStore'

import { printUIClose, printUIOpen, setPrintReport } from 'utils/Print/actions'

const ToolsPrint: React.FC = () => {
  const dispatch = useDispatch()
  const printUIVisible = useSelector((state: RootState) => state.printUIVisible)

  const handlePrint = () => {
    if (printUIVisible) {
      dispatch(printUIClose())
    } else {
      // Remove any existing print report settings, so this is not added to the print page
      dispatch(setPrintReport())
      dispatch(printUIOpen())
    }
  }

  return (
    <div>
      <Button variant="outlined" sx={{ width: '14em' }} onClick={handlePrint}>
        <PrintIcon />Print
      </Button>
    </div>
  )
}

export default ToolsPrint
